import { Injectable } from "@angular/core";
import { PreloadingStrategy, Route } from "@angular/router";
import { Observable, of } from "rxjs";

@Injectable({ providedIn: "root" })
export class IdlePreloadingStrategy implements PreloadingStrategy {
  preload(route: Route, load: () => Observable<unknown>): Observable<unknown> {
    if (route.data && route.data["preload"]) {
      return new Observable((observer) => {
        const idleCallback =
          window.requestIdleCallback || ((cb) => setTimeout(cb, 1));
        idleCallback(() => {
          load().subscribe(observer);
        });
      });
    } else {
      return of(null);
    }
  }
}
